var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIconFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2261 14.25C20.8161 14.25 20.4761 14.59 20.4761 15V18C20.4761 18.69 19.9161 19.25 19.2261 19.25H5.22607C4.53607 19.25 3.97607 18.69 3.97607 18V15C3.97607 14.59 3.63607 14.25 3.22607 14.25C2.81607 14.25 2.47607 14.59 2.47607 15V18C2.47607 19.52 3.70607 20.75 5.22607 20.75H19.2261C20.7461 20.75 21.9761 19.52 21.9761 18V15C21.9761 14.59 21.6361 14.25 21.2261 14.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.696 16.53C11.846 16.68 12.036 16.75 12.226 16.75C12.416 16.75 12.606 16.68 12.756 16.53L16.756 12.53C17.046 12.24 17.046 11.76 16.756 11.47C16.466 11.18 15.986 11.18 15.696 11.47L12.976 14.19V4C12.976 3.59 12.636 3.25 12.226 3.25C11.816 3.25 11.476 3.59 11.476 4V14.19L8.75602 11.47C8.46602 11.18 7.98602 11.18 7.69602 11.47C7.40602 11.76 7.40602 12.24 7.69602 12.53L11.696 16.53Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIconFilled);
export default __webpack_public_path__ + "static/media/download_icon_filled.cd513a3656b13c8884462bcc2a27d9f5.svg";
export { ForwardRef as ReactComponent };